import { Flex, Link as BPLink } from '@resideo/blueprint-react';
import styled from 'styled-components';

export const Container = styled(Flex)`
  max-width: 700px;
  margin-top: 32px;
  justify-content: space-between;
  align-items: end;

  &:last-child {
    margin-bottom: 32px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}) {
    align-items: center;
  }
`;

export const Content = styled(Flex)`
  flex-direction: column;
  margin-right: 40px;
`;

export const Action = styled(Flex)`
  white-space: nowrap;
  font-weight: 500;
  width: 110px;
  flex: 0 0 auto;
  justify-content: end;
`;

export const Title = styled.p`
  margin: 0;
`;

export const SubTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.faded};
`;

export const Link = styled(BPLink)`
  text-decoration: underline;
`;
